import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const rate: ApiMethod<Server.RateContentEntityV2Input, void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Rating_Client(undefined, contentClient);

    const response = await client.rating_rate_post_V2(data);

    if (response.success) {
      dispatch(
        CommonActions.setAlert({
          type: AlertType.SUCCESS,
          messages: [
            { message: 'تمت عملية التقييم بنجاح', code: 200, field: 'rating' },
          ],
        })
      );
      return;
    }

    rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    rejectWithValue(error);
  }
};
